export default {
  title: 'Estimado usuario',
  description:
    'Desactiva tu WiFi y activa tus datos para disfrutar de la experiencia completa en este portal.',
  more_info: 'Recuerda que la navegación en este portal no consume datos.',
  button: 'Continuar'
}
